module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_1",
      "title": "1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Secret Agent 00Zero (also known as Jackson to his mom) wiped the frost off his icePad and handed it to his best friend, Quigley. “Ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sure!” Quigley said, pointing the icePad camera at the sled behind Jackson. “The Ice Blaster looks awesome on-screen.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jackson smiled. “Great, but remember to get "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("me")]), _vm._v(" in the shot, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Quigley’s face turned shrimp pink. “Oh, yeah,” he mumbled, stepping back to include Jackson in the picture. “Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/Spy_Penguins_Chapter_1_P2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_2",
      "title": "2"
    }
  }, [_vm._v("Jackson sighed. Quigley was supposed to be filming Jackson riding the sled down Frostbite Ridge—the giant iceberg above Rookeryville, where they lived. But so far it looked like the video was going to be ALL sled and NO Jackson. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("But")]), _vm._v(", Jackson reminded himself, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("this is no ordinary sled")]), _vm._v(". It was Quigley’s latest and greatest invention: a super-speedy, ice-blasting spy-getaway vehicle with four giant rocket blasters on the back. A sled so epic, Jackson thought it could be the answer to his dreams …")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_3",
      "title": "3"
    }
  }, [_vm._v("“Let’s do this!” Jackson put on his sunglasses and shook out his feathers so they stood up on end, making him look tough. Because you had to be tough if you wanted to be a secret agent working for the FBI (the Frosty Bureau of Investigation). And joining the FBI was the reason they were shooting the video. It was the thing Jackson wanted more than anything else in the world. Even more than he wanted his favorite flipper-ball team, the Toothfish, to win the league pennant. All he had to do was convince the FBI that they needed him.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Quigley pointed the icePad at Jackson. “FBI audition video, take one.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jackson took a deep breath. “Hi, I’m Secret Agent 00Zero,” he said, staring into the camera with a serious look on his face. “I’m here today to show you—the bosses at the FBI—why you should hire me as a trainee secret agent. Oh, and you’ll definitely want to hire my buddy, too—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_4",
      "title": "4"
    }
  }, [_vm._v("Quigley spun the icePad around to himself. “Hi there!” He beamed into the lens before turning it back to Jackson.")])]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/Spy_Penguins_Chapter_1_P4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“That was Secret Agent Q,” Jackson said. “We’ve been friends since we were eggs. He’s the greatest gadget inventor in Rookeryville—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Quigley coughed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Err, make that the WORLD!” Jackson winked at Quigley, then went back to looking serious again. “This is one of Agent Q’s inventions.” He waggled his flipper at the sled. “And "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_5",
      "title": "5"
    }
  }, [_vm._v("I’m going to use it to demonstrate my secret-agent driving skills. Let’s do this!” Jackson gave a flippers-up, then climbed aboard the sled. He gripped the steering wheel with both wings and pushed his foot down on the accelerator pedal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nothing happened.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Err—Quigley,” Jackson whispered. “I’m still here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Quigley peered around the side of the icePad. “Maybe it just needs a shove.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As Quigley’s foot made contact with the back of the sled there was a loud "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("VAROOM!")]), _vm._v(" The rocket blasters exploded to life, burping out a plume of stinky seaweed-smelling smoke and shooting the sled forward, nearly knocking Jackson off his seat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Whoa!” he breathed as he zoomed down the slope, his spiky yellow crest flapping in the icy wind. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("If this doesn’t show them, nothing will!")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_6",
      "title": "6"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("VHOOSH!")]), _vm._v(" He steered the sled left to avoid a giant boulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("VHOOSH!")]), _vm._v(" He steered right to miss three dad penguins out for a huddle with their eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("VHOOSH!")]), _vm._v(" He steered left to avoid heading down the path to the Cliff of Doom, but suddenly the sled seemed to hiccup. And then splutter. And then—")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/Spy_Penguins_Chapter_1_P6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_7",
      "title": "7"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Ahhhhhh!")]), _vm._v("” Jackson screamed. Or he would have if he hadn’t been a secret agent, because secret agents weren’t allowed to scream, even when they were racing down an iceberg and the steering wheel of their getaway vehicle had just come off in their flippers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_8",
      "title": "8"
    }
  }, [_vm._v("“Help!” Jackson yelled, breaking the secret-agent rule of never shouting for help on a secret spy mission, on account of the sled having, by itself, turned right—a VERY, VERY, EXTREMELY HARD RIGHT—which meant it was now out of control and hurtling toward the Cliff of Doom.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Don’t panic")]), _vm._v(", Jackson told himself. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Secret agents never panic.")]), _vm._v(" Jackson knew this because his Uncle Bryn was a real-life secret agent with the FBI. And Uncle Bryn never panicked, even when he mislaid his secret-agent tool kit, which happened at least twice a week.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jackson looked desperately at the dashboard. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("There has to be a way to stop this thing.… Wait.… What’s that?")]), _vm._v(" He noticed a small red button with Quigley’s squiggly writing underneath. Jackson tried to read the writing, hoping it might say p-a-r-a-c-h-u-t-e. But instead, “M-R-jen-C,” he read aloud. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Huh?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_9",
      "title": "9"
    }
  }, [_vm._v("There was no time to figure it out. He hit the button and held his breath as the ground below him vanished and he shot over the Cliff of Doom.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("For one feather-clenching moment nothing happened. The sled just sort of sailed through the sky, minding its own business. And Jackson felt a bubble of hope in his belly. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Maybe this is actually a flying secret spy-getaway vehicle")]), _vm._v(", he thought. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Maybe Quigley really is a genius—")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Or maybe not. Jackson gripped the sides of the sled as it suddenly stopped minding its own business and began f-a-l-l-i-n-g.…")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“HELP!” Jackson tried slapping the M-R-jen-C button again and again. But nothing happened. “Sucking squids! Do something!” he yelled at the sled.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And it did.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A giant split appeared in the floor between Jackson’s feet.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_10",
      "title": "10"
    }
  }, [_vm._v("“Noooo! I’m doomed,” he groaned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But just then there was a loud "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("whoosh")]), _vm._v(" and four enormous shapes burst out of the split. And the sled suddenly yo-yoed back up into the air, jerking and twisting as four giant inflating helium balloons bobbed against one another.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/Spy_Penguins_Chapter_1_P10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_11",
      "title": "11"
    }
  }, [_vm._v("“Quigley, you "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("are")]), _vm._v(" a genius!” Jackson breathed as he gently glided up, up, up through the air over Rookeryville.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jackson craned his neck over the side. He could see his school … and the park … and Brain Freezers. Brain Freezers was the best milk shake shack in Rookeryville; it had amazing seaweed shakes. Jackson tried to see if anyone was sitting in his and Quigley’s favorite seats in the window. Mission Control, they called it. It was the place where they hatched all their best FBI-joining schemes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jackson was so busy thinking about Brain Freezers that he didn’t spot the large shape looming out of the clouds toward him until it was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Stop! No!” He shook his flippers wildly at the gigantic bird soaring straight toward him. “LOOK OUT!” he yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img90",
    attrs: {
      "alt": "",
      "src": "images/Spy_Penguins_Chapter_1_P12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_12",
      "title": "12"
    }
  }, [_vm._v("But the albatross obviously didn’t speak penguin.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SQUAWK!")]), _vm._v(" And suddenly the sky was a messy jumble of wings, sled, feathers, beaks, balloons, claws—SUPER-SHARP BALLOON-POPPING CLAWS—")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And—")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("POP! POP! POP! POP! H-i-s-sssssssss.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("For the second time in five minutes Jackson found himself dropping from the sky. He shut his eyes as the air whistled past his ears and he waited for the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("splat")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_13",
      "title": "13"
    }
  }, [_vm._v("Except it wasn’t a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SPLAT")]), _vm._v(". It was more of a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sploosh")]), _vm._v(", as everything turned greeny-blue and bubbly and wet, and slightly fish-pooey stinky.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The sea!” Jackson shouted, sending a stream of air bubbles out of his beak. “I landed in the sea.” Which was odd, because he was pretty sure he’d been right above the town when he’d started falling. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("But I’ve always been a lucky kind of penguin")]), _vm._v(", he reminded himself as he swam upward, scattering a group of strange-looking giant fish. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Must remember to tell the FBI how lucky I am. All secret agents need a feather or two of luck.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Jackson was still thinking about how lucky he was when he reached the surface and poked his head out—")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Huh?” He looked around. This did NOT look like the sea. It was more like … a pond, he guessed, glancing around. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A large pond with")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_14",
      "title": "14"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("buildings all around and—and— Wait! Who are all those scary-looking penguin dudes in dark glasses with ICE LASERS POINTING AT MY HEAD?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“FREEZE!” one shouted. “Or we’ll ice you into oblivion.”")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "images/Spy_Penguins_Chapter_1_P14_rev.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739cb62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0